import { useCallback } from 'react'
import { useNavigate } from 'react-router'

import { useUserOrganization } from '@modules-deprecated/app/organization/userOrganizationContext'

import { getOrganizationViewUrl } from '../../../../../../../utils/routing/getOrganizationViewUrl'
import { reactRoute } from '../../../../../../../utils/routing/reactRoute'
import { useInvoice } from '../../../contexts/invoiceContext'

export const useCreateCreditNote = () => {
  const navigate = useNavigate()
  const { organization } = useUserOrganization()
  const { invoiceId } = useInvoice()

  const createCreditNote = useCallback(() => {
    navigate(
      getOrganizationViewUrl(
        organization?.url,
        reactRoute.organization.invoices.getCreditNoteFromInvoiceRoute(String(invoiceId)),
      ),
    )
  }, [invoiceId, navigate, organization?.url])

  return { createCreditNote }
}
